// youtube.js
// Utility to overlay YouTube thumbnails on iframes and autoplay on click

/**
 * Scans for YouTube iframes, overlays thumbnails, and enables click-to-autoplay.
 * @param {string} selector - CSS selector for YouTube iframes (default: 'iframe').
 */
export function setupYouTubeOverlays(selector = '.blocks__video__iframe__overlay') {
  // Find all overlays that should become lazy YouTube embeds
  const overlays = Array.from(document.querySelectorAll(selector));
  overlays.forEach(overlay => {
    // Only proceed if not already initialized
    if (overlay.dataset.youtubeInitialized) return;
    overlay.dataset.youtubeInitialized = '1';
    // Find the data-youtube or data-src attribute or child iframe with src
    let videoId = null;
    let src = '';
    // Try data-youtube attribute
    if (overlay.dataset.youtube) {
      videoId = overlay.dataset.youtube;
    } else {
      // Try to find iframe child with src
      const iframe = overlay.querySelector('iframe');
      if (iframe && iframe.src) {
        const ytMatch = iframe.src.match(/(?:youtube\.com\/embed\/|youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/);
        if (ytMatch) videoId = ytMatch[1];
      }
    }
    if (!videoId) return;
    // Clean overlay
    overlay.innerHTML = '';
    // Thumbnail image (try HD first, fallback to HQ)
    const img = document.createElement('img');
    img.src = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    img.alt = 'YouTube Thumbnail';
    img.className = 'blocks__video__youtube__thumb';
    // Fallback to HQ if HD not available
    img.onerror = function() {
      if (img.src.includes('maxresdefault')) {
        img.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
      }
    };
    overlay.appendChild(img);
    // Play button overlay
    const playBtn = document.createElement('div');
    playBtn.className = 'blocks__video__iframe__overlay__playbtn';
    playBtn.innerHTML = '▶';
    overlay.appendChild(playBtn);
    // Add two separate line elements
    const line1 = document.createElement('div');
    line1.className = 'blocks__video__iframe__overlay__line';
    const line2 = document.createElement('div');
    line2.className = 'blocks__video__iframe__overlay__line';
    overlay.appendChild(line1);
    overlay.appendChild(line2);
    // On click, replace overlay with iframe
    overlay.onclick = () => {
      const iframe = document.createElement('iframe');
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.className = 'blocks__video__youtube__iframe';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      overlay.replaceWith(iframe);
      iframe.focus();
    };
  });
}
